<template>
  <div class="c-button-recharge" :class="[disabled ? 'btn-disabled':'',commend ? 'commend':'']">
    <div class="title">{{ title }}</div>
    <div class="desc">{{ desc }}</div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-button-recharge',
    props: {
      title: {
        type: String,
        default: ''
      },
      desc: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      commend: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?35dc0368